import { css, styled } from '@mui/material';

export const StyledContractOverviewCard = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    padding: ${theme.spacing('LARGE')};
    row-gap: ${theme.spacing('LARGE')};
  `
);

export const StyledContractOverviewCardHeader = styled('div')(
  ({ theme }) => css`
    align-items: center;
    column-gap: ${theme.spacing('LARGE')};
    display: flex;

    svg {
      height: ${theme.spacing('1XL')};
      width: ${theme.spacing('1XL')};
    }
  `
);

export const StyledSpacer = styled('div')`
  flex-grow: 1;
`;

export const StyledContractOverviewCardText = styled('div')(
  ({ theme }) => css`
    color: ${theme.palette.text.customerOverviewCard};
    column-gap: ${theme.spacing('LARGE')};
    display: flex;
  `
);

export const StyledContractOverviewCardCancellationStatus = styled('div')(
  ({ theme }) => css`
    border: 1px solid ${theme.palette.common.white};
    border-radius: 14px;
    padding-left: ${theme.spacing('SMALL')};
    padding-right: ${theme.spacing('SMALL')};
    width: fit-content;
  `
);

export const StyledContractOverviewCardCancellationLink = styled('div')(
  ({ theme }) => css`
    align-items: center;
    display: flex;
    column-gap: ${theme.spacing('XSMALL')};

    svg {
      height: ${theme.spacing('LARGE')};
      width: ${theme.spacing('LARGE')};
    }
  `
);
